module.exports = __webpack_public_path__ + "static/media/hourglass.8ddc8029.webp";